import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface ConsignmentStatusDatetimeDialogData {
    actionLabel: string;
}

@Component({
    selector: 'app-consignment-status-datetime-dialog',
    templateUrl: './consignment-status-datetime-dialog.component.html',
    styleUrls: ['./consignment-status-datetime-dialog.component.scss'],
})
export class ConsignmentStatusDatetimeDialogComponent {
    /** Bound to datetime-local input (yyyy-MM-ddThh:mm in local time). */
    selectedDatetime: string;

    constructor(
        public dialogRef: MatDialogRef<ConsignmentStatusDatetimeDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ConsignmentStatusDatetimeDialogData
    ) {
        const now = new Date();
        const y = now.getFullYear();
        const m = String(now.getMonth() + 1).padStart(2, '0');
        const d = String(now.getDate()).padStart(2, '0');
        const h = String(now.getHours()).padStart(2, '0');
        const min = String(now.getMinutes()).padStart(2, '0');
        this.selectedDatetime = `${y}-${m}-${d}T${h}:${min}`;
    }

    cancel(): void {
        this.dialogRef.close(undefined);
    }

    confirm(): void {
        if (!this.selectedDatetime) {
            this.dialogRef.close(undefined);
            return;
        }
        const date = new Date(this.selectedDatetime);
        this.dialogRef.close(date.toISOString());
    }
}
